import { createReducer, on } from '@ngrx/store';
import { domainsAdapter, initialDomainsState } from './domains.adapter';
import { RequestStatus } from '../../enums/request-status.enum';
import * as DomainsActions from './domains.actions';

export const domainsReducer = createReducer(
  initialDomainsState,

  on(DomainsActions.loadDomains, (state) => ({
    ...state,
    status: RequestStatus.Loading,
    error: null,
  })),

  on(DomainsActions.loadDomainsSuccess, (state, { domains }) => {
    return domainsAdapter.setAll(domains, {
      ...state,
      status: RequestStatus.Success,
      error: null,
    });
  }),

  on(DomainsActions.loadDomainsFailure, (state, { error }) => ({
    ...state,
    status: RequestStatus.Error,
    error,
  })),

  on(DomainsActions.setCurrentDomainId, (state, { domainId }) => ({
    ...state,
    currentDomainId: domainId,
  }))
);

